import * as Sentry from '@sentry/nuxt'
import { defineComponent } from 'vue'

export type DateUtilsValidInput = string | number | Date

/**
 * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
 */
export default defineComponent({
  methods: {
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    getDateSpread(date: DateUtilsValidInput) {
      const dateObj = new Date(date)
      const dd = dateObj.getUTCDate()
      const mm = dateObj.getUTCMonth() + 1
      const yy = dateObj.getUTCFullYear()

      return { dd, mm, yy, dateObj } as const
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    formatDate(date: DateUtilsValidInput, separator = '/'): string {
      const { dd, mm, yy } = this.getDateSpread(date)
      let day = dd.toString()
      let month = mm.toString()

      if (dd < 10) day = `0${day}`

      if (mm < 10) month = `0${month}`

      return (
        this.$t('dateUtils.fullDate', {
          day,
          month,
          year: yy,
        }) as string
      ).replace(/\//gi, separator)
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    getMonthTextFromMonthIndex(
      index: number,
      displayType = 'full' as 'short' | 'full',
    ): string {
      if (index < 0 || index > 11)
        Sentry.captureException(new Error(`${index} is outside of month rage`))

      return this.$t(`dateUtils.months.${displayType}.${index}`)
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    formatToTextDate(
      date: DateUtilsValidInput,
      long = false,
      separator = ' ',
      monthSuffix = '',
    ): string {
      const { dd, dateObj } = this.getDateSpread(date)

      const month =
        this.getMonthTextFromMonthIndex(
          dateObj.getMonth(),
          long !== true ? 'short' : 'full',
        ) + monthSuffix

      return this.$t('date.shortDate', {
        dd,
        month,
        separator,
      }) as string
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    formatToDateTextWithYear(
      date: DateUtilsValidInput,
      long = false,
      separator = ' ',
    ): string {
      return `${this.formatToTextDate(
        date,
        long,
        separator,
      )}${separator}${new Date(date).getFullYear()}`
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    formatToTextFullDate(date: DateUtilsValidInput): string {
      const { dd, yy, dateObj } = this.getDateSpread(date)
      const month = this.getMonthTextFromMonthIndex(dateObj.getMonth())

      return `${dd} ${month} ${yy}`
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    getDistanceSpread(date: DateUtilsValidInput): {
      y: number
      mm: number
      d: number
      h: number
      m: number
    } {
      date = new Date(date).getTime() / 1000
      const now = Date.now() / 1000
      const diff = now - date
      const m = diff / 60
      const h = m / 60
      const d = h / 24
      const mm = d / 30
      const y = d / 365

      return { m, h, d, mm, y }
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    getCountdownSpread(date: DateUtilsValidInput): {
      y: number
      mm: number
      d: number
      h: number
      m: number
    } {
      date = new Date(date).getTime() / 1000
      const now = Date.now() / 1000
      const diff = date - now
      const m = diff / 60
      const h = m / 60
      const d = h / 24
      const mm = d / 30
      const y = d / 365

      return { m, h, d, mm, y }
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    getCountdown(date: DateUtilsValidInput) {
      const { m, h, d } = this.getCountdownSpread(date)
      let ret = ''

      if (d >= 2) {
        return Math.floor(d) + ' ' + this.$t('time.d', Math.floor(d))
      } else if (h > 1) {
        return (
          this.quickNumFormat(Math.floor(h)) + this.$t('time.h', Math.floor(h))
        )
      } else {
        ret =
          this.quickNumFormat(Math.floor(m)) + this.$t('time.m', Math.floor(m))
      }

      if (m <= 0) return '-'

      return ret
    },
    /**
     * @deprecated use date-fns, utils/DateDisplay.ts or utils/dates.ts
     */
    quickNumFormat(num: number | string): string {
      num = num.toString()

      if (num.length < 2) return '0' + num
      else return num
    },
  },
})
